import { useEffect, useState } from "react";
import {
  useAccountsStore,
  useNotificationStore,
} from "../../../../stores/ConfigStore";
import {
  Blockquote,
  Button,
  Checkbox,
  Group,
  InputLabel,
  LoadingOverlay,
  Modal,
  PinInput,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import {
  checkpointLinkedin,
  getLinkedinAccounts,
} from "../../../../api/EmailAPI";
import { useLanguage } from "../../../../stores/LanguageStore";

const LinkedinCheckpoint = () => {
  const lang = useLanguage((s) => s.language);
  const accounts = useAccountsStore((s) => s.linkedin_accounts);

  const needVerifIgnores = useNotificationStore((s) => s.needVerifIgnores);
  const setNeedVerifIgnores = useNotificationStore(
    (s) => s.setNeedVerifIgnores
  );
  const account = useAccountsStore((s) => s.accountVerif);
  const setAccount = useAccountsStore((s) => s.setAccountVerif);
  const [isCode, setIsCode] = useState(true);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [dontShowAgain, setDontShowAgain] = useState(true);

  const onClose = () => {
    setAccount(null);

    setNeedVerifIgnores([...needVerifIgnores, account.id]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setError(null);
    setLoading(true);
    checkpointLinkedin({ id: account?.id, code: isCode ? data.code : "000000" })
      .then((r) => {
        if (account?.onFinish) {
          account.onFinish();
        } else {
          let reloadButton = document.getElementById("linkedin-table-reload");

          if (reloadButton) {
            reloadButton.click();
          }
        }

        getLinkedinAccounts().finally(() => {
          setAccount(null);
          setLoading(false);
          setNeedVerifIgnores(needVerifIgnores.filter((x) => x !== account.id));
        });
      })
      .catch((err) => {
        setError(
          err.response?.data?.error
            ? JSON.stringify(err.response?.data?.error || "")
            : ""
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    let x = accounts.find((x) => x.checkpoint_required);
    if (account) {
      setAccount(account);
    } else {
      if (x && !needVerifIgnores.includes(x.id)) {
        setAccount(x);
      }
    }
  }, [account, accounts, needVerifIgnores]);

  return (
    <Modal
      opened={!!account}
      size={540}
      title={`${lang.components.linkedin_checkpoint.title}: ${account?.name} #${account?.id}`}
      onClose={onClose}
      centered
    >
      <LoadingOverlay visible={loading} />
      <Stack component={"form"} onSubmit={handleSubmit}>
        <Blockquote p={"sm"}>
          <Text>{lang.components.linkedin_checkpoint.text1}</Text>
        </Blockquote>

        <Checkbox
          label={lang.components.linkedin_checkpoint.code_check_label}
          checked={isCode}
          onChange={(e) => setIsCode(e.target.checked)}
          size="md"
        />

        {isCode && (
          <>
            <InputLabel size="md" mb={-12}>
              {lang.components.linkedin_checkpoint.code_label} :
            </InputLabel>
            <PinInput
              name="code"
              required
              size="md"
              error={error}
              length={6}
              disabled={!isCode}
              mb={12}
            />
          </>
        )}

        <Checkbox
          label={lang.components.linkedin_checkpoint.nocode_check_label}
          checked={!isCode}
          onChange={(e) => setIsCode(!e.target.checked)}
          size="md"
        />

        {!isCode && (
          <Text c={"primary"} fw={500}>
            {lang.components.linkedin_checkpoint.nocode_desc}
          </Text>
        )}

        <Group justify="center" mt={"md"}>
          {/* <Checkbox
            label={lang.global.dont_show_again}
            checked={dontShowAgain}
            onClick={(e) => setDontShowAgain(e.target.checked)}
            size="md"
          /> */}
          <Button size="md" type="submit">
            {lang.components.linkedin_checkpoint.submit}
          </Button>

          {error && (
            <Text c={"red"} fw={500}>
              {lang.components.linkedin_checkpoint.error1}
            </Text>
          )}
        </Group>
      </Stack>
    </Modal>
  );
};

export default LinkedinCheckpoint;
